export default "__VITE_ASSET__DFlrOYQC__"